import { ref } from 'vue'
import { APIClient } from '@wharfkit/antelope'
import { ContractKit } from '@wharfkit/contract'
import { fetchApi } from '@/utils.js'
import { displayTokenValue } from '@exsat/common/utils.js'
import * as configMap from '@exsat/common/config.js'
export function useTotalCount() {
  const exsatConfig = configMap.mainnet
  const contractKit = new ContractKit({ client: new APIClient({ url: exsatConfig.contractUrl }) })

  const stats = ref({
    btcTotalStaking: '-',
    btcTotalValidators: '-',
    xsatTotalValidators: '-',
    xsatTotalStaking: '-',
    syncedBlockHeight: 0,
    hashrateShare: '-',
    parsedHeight: 0,
    totalSynchronizers: '-'
  })

  async function initTable(contractName, tableName, rows = 20) {
    const contract = await contractKit.load(contractName)
    const table = contract.table(tableName)
    const cursor = table.query({
      from: 0,
      reverse: true,
      maxRows: rows
    })
    cursor.table = table
    return cursor
  }
  /**
   * 获取区块链状态信息
   *
   * @returns 返回包含解析高度、头部高度和不可逆转高度的对象
   */
  async function getState() {
    // 初始化表格
    const { table } = await initTable('utxomng.xsat', 'chainstate')

    // 获取链状态
    const chainState = await table.get()

    // 解析链状态中的高度
    const parsing_height = Number(chainState.parsing_height)

    const parsed_height = Number(chainState.parsed_height)

    // 获取链头高度
    const head_height = Number(chainState.head_height)
    // 获取不可逆转高度
    const irreversible_height = Number(chainState.irreversible_height)

    // 返回解析高度、链头高度和不可逆转高度
    return {
      parsing_height,
      head_height,
      parsed_height,
      irreversible_height
    }
  }

  async function getTableData() {
    // 获取当前状态信息
    const { parsed_height, irreversible_height } = await getState()
    // 更新统计信息中的同步区块高度
    stats.value.syncedBlockHeight = irreversible_height

    stats.value.parsedHeight = parsed_height
  }

  async function getBtcValidators() {
    const contract = await contractKit.load('endrmng.xsat')
    const table = contract.table('validators')
    const cursor = table.query()

    let records = await cursor.all()

    records = records
      .filter((v) => v.role.toString() != 1)
      .filter((record) => {
        const stakeCount = record.qualification?.toString().split(' ')[0] ?? '0'
        return stakeCount >= 100
      })

    stats.value.btcTotalValidators = records.length
  }
  async function getXsatValidators() {
    const contract = await contractKit.load('endrmng.xsat')
    const table = contract.table('validators')
    const cursor = table.query({
      index_position: 'sixth',
      key_type: 'i64',
      from: 4294967296
    })

    // Shouldn't be too many rows
    let records = await cursor.all()

    records = records.filter((record) => {
      const stakeCount = record.xsat_quantity?.toString().split(' ')[0] ?? '0'
      return stakeCount >= 100
    })

    stats.value.xsatTotalValidators = records.length
  }
  async function getTotalStaking() {
    const { table } = await initTable('endrmng.xsat', 'stat')
    const result = await table.get()
    stats.value.btcTotalStaking = result.total_staking.quantity
    stats.value.xsatTotalStaking = result.xsat_total_staking.quantity
  }
  async function getConsensusInfo() {
    const result = await fetchApi('/v1/validator/utxo-consensus')
    stats.value.hashrateShare = result.hashRateShare
  }
  async function getSynchronizers() {
    const contract = await contractKit.load('poolreg.xsat')
    const table = contract.table('synchronizer')
    const cursor = table.query()

    // Shouldn't be too many rows
    const records = await cursor.all()

    stats.value.totalSynchronizers = records.length
  }
  function init() {
    getTableData()
    getBtcValidators()
    getXsatValidators()
    getTotalStaking()
    getConsensusInfo()
    getSynchronizers()
  }
  init()
  return {
    stats,
    displayTokenValue
  }
}
